<template>
  <div>
    <el-table
      :data="detailList"
      stripe
      border
      style="width: 100%"
      header-row-class-name="header_table_row"
    >
      <el-table-column
        prop="descr"
        min-width="180"
        label="问题描述"
        align="center"
      >
        <template slot-scope="scope">
          <div style="text-align: left">{{ scope.row.descr }}</div>
        </template>
      </el-table-column>
      <el-table-column
        prop="department"
        min-width="120"
        label="所在科室"
        align="center"
      >
      </el-table-column>
      <el-table-column
        prop="repairBy"
        width="100"
        label="报修人"
        align="center"
      >
      </el-table-column>
      <el-table-column
        prop="maintainerName"
        width="100"
        label="处理人"
        align="center"
      >
      </el-table-column>
      <el-table-column
        prop="isException"
        width="100"
        label="工单状态"
        align="center"
      >
        <template slot-scope="scope">
          <div :style="scope.row.isException ? 'color:red' : ''">
            {{ scope.row.isException ? "异常" : "正常" }}
          </div>
        </template>
      </el-table-column>
      <el-table-column width="80" label="操作" align="center">
        <template slot-scope="scope"
          ><div
            @click="onToInfo(scope.row)"
            style="color: #2d8cf0; cursor: pointer"
          >
            详情
          </div></template
        >
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
  props: {
    detailList: {
      type: Array,
      default: [],
    },
  },
  data() {
    return {};
  },
  created() {
    console.log(this.detailList);
  },
  methods: {
    onToInfo(row) {
      this.$Modal.remove();
      $utils.url.push({
        name: "workOrder_info",
        query: { action: "edit", kv: row.id },
      });
    },
  },
};
</script>

<style>
</style>